<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="收款记录" prop="income_id">
                            <Select v-model="Forms.income_id" clearable filterable  placeholder="收款记录" @on-change="getMoney">
                                <Option v-for="(item,index) in incomeList" :key="index" :value="item.id">{{item.sn}}<small class="text-orange"> [{{item.is_invoice_name}}] </small>({{item.project_name}})</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票金额" prop="inv_money">
                            <Input v-model="Forms.inv_money" type="number" clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="到账金额" prop="get_money">
                            <Input v-model="Forms.get_money" type="number" disabled clearable placeholder=""/>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票类型" prop="inv_type">
                            <Select v-model="Forms.inv_type" clearable filterable  placeholder="收款类型" class="width-100">
                                <Option v-for="(item,index) in invTypeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开票公司" prop="inv_company_id">
                            <Select v-model="Forms.inv_company_id" clearable filterable  placeholder="开票公司" class="width-100">
                                <Option v-for="(item,index) in invCompanyList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票抬头" prop="inv_head">
                            <Input v-model="Forms.inv_head" class="width-70" clearable placeholder="" />
                            &nbsp;<Button type="primary" class="width-27" ghost @click="getContact">自动获取</Button>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票税号" prop="inv_num">
                            <Input v-model="Forms.inv_num" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="发票地址" prop="inv_address">
                            <Input v-model="Forms.inv_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="inv_bank">
                            <Input v-model="Forms.inv_bank" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认开发票</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getIncomeInvoice} from "@/apis/income";
import {getInvoiceConfig, getInvoiceDetail, oSaveInvoice} from "@/apis/invoice";

export default {
    name: 'IncomeInvoice',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '补开发票',
            isBox : false,
            incomeList: [],
            invTypeList: [],
            invCompanyList: [],
            Forms : {
                inv_id:'',
                income_id: '',
                inv_money: '',
                get_money: '',
                inv_type: '',
                inv_company_id: '',
                inv_head: '',
                inv_num: '',
                inv_address: '',
                inv_bank: '',
                remark: ''
            },
            Rules : {
                income_id: [
                    { required: true, type: 'number',  message: '请选择收款记录', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                inv_money: [
                    { required: true, type: 'number',  message: '请输入开票金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                inv_type: [
                    { required: true, type: 'number',  message: '请选择发票类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                inv_company_id: [
                    { required: true, type: 'number',  message: '请选择开票公司', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                inv_head: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur'}
                ],
                inv_num: [
                    { required: true, message: '请输入发票税号', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        /**
         功能：
         time: 2026/1/7 09:17
         **/
        getMoney(e){
            let that = this;
            if(e){
                that.incomeList.forEach(item => {
                    if(item.id === e) that.Forms.get_money = item.get_money;
                })
            }
        },
        /**
         功能：
         time: 2026/1/7 09:22
         **/
        getContact(){
            let that = this;
            if(!that.Forms.income_id){
                that.$Message.error({ background: true,duration:3, content: '请选择收款记录'});
                return;
            }
            getIncomeInvoice(that.Forms.income_id).then(e => {
                let data = e.data;
                that.Forms.inv_head = data.inv_head ?? '';
                that.Forms.inv_num = data.inv_num ?? '';
                that.Forms.inv_bank = data.inv_bank ?? '';
                that.Forms.inv_address = data.inv_address ?? '';
            })
        },
        /**
         功能：
         time: 2025/12/25 16:29
         **/
        GetConfig(){
            let that = this;
            getInvoiceConfig().then(e=>{
                that.incomeList = e.data.incomeList ?? [];
                that.invTypeList = e.data.invTypeList ?? [];
                that.invCompanyList = e.data.invCompanyList ?? [];
            })
        },

        GetDetail(inv_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getInvoiceDetail(inv_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'income_id' || v === 'inv_type' || v === 'inv_company_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                console.log(that.Forms)
            })
        },
        /**
         功能：
         time: 2025/12/25 16:08
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2026/1/7 09:50
         **/
        edit(inv_id){
            this.isBox = true;
            this.GetConfig();
            if(inv_id) this.GetDetail(inv_id);
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    oSaveInvoice(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2026/1/7 09:41
         **/
        FormReset(){
            this.isBox = false;
            this.title = '开发票';
            this.$refs['Forms'].resetFields();
            this.Forms.incomeList = [];
            this.Forms.invTypeList = [];
            this.Forms.invCompanyList = [];
            this.Forms.inv_id = '';
            this.Forms.income_id = '';
            this.Forms.get_money = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
